export function initTextInput() {
  const textInputs = document.querySelectorAll('.text-input');

  textInputs.forEach((label) => {
    const input = label.querySelector('input, textarea');
    if (!input) {
      console.warn('Input element is missing in ', label);
      return;
    }

    const form = input.form;

    const update = () => {
      if (document.activeElement === input || input.value.trim() !== '') {
        label.classList.add('text-input--is-active');
      } else {
        label.classList.remove('text-input--is-active');
      }
    };

    input.addEventListener('focus', update);
    input.addEventListener('blur', update);
    input.addEventListener('input', update);

    if (form) {
      form.addEventListener('reset', () => {
        setTimeout(update); // Wait for form values to reset
      });
    }

    update();
  });
}
